<!-- 储值卡扣费流水上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody:{
                "actPayCharge": 4,
                "billCode": "2017092917212596518095",
                "cmd": "reportParkingFee",
                "collectorName": "liuzhe",
                "isArrear": 0,
                "parkCode": "2KM43Y461",
                "parkingCode": "2017092917190870323542",
                "payDate": "20170929172115",
                "payMode": 1,
                "payOrigin": 1,
                "platformShouldPay": 0,
                "reliefCharge": 0
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场临停交费信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportParkingFee",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场, 路边车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '如通过开放平台缴费接口缴费，则为缴费时的billCode；否则为停车场端的缴费订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '实付金额' },
                        { info1: 'reliefCharge', info2: '是', info3: 'Decimal', info4: '线下本地优惠金额、自动优惠金额，不包含商家券优惠金额，为空填0' },
                        { info1: 'desc', info2: '是', info3: 'String', info4: '备注说明' },
                        { info1: 'payMode', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData#appendixData_0</url>）' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（<url>参考附录:/Api/appendixData#appendixData_1</url>）' },
                        { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'collectorName', info2: '否', info3: 'String', info4: '收费员' },
                        { info1: 'isArrear', info2: '是', info3: 'Integer', info4: '是否欠费补缴记录：0否，1是' },
                        { info1: 'platformShouldPay', info2: '是', info3: 'String', info4: '平台应补扣金额，自动扣费时使用' },
                        { info1: 'shouldCharge', info2: '是', info3: 'Decimal', info4: '应收金额（vems v2.18开始 vems开始传此值，之前版本默认为：shouldCharge=actPayCharge+couponValue<可能多个>）' },
                        { info1: 'isAbnormal', info2: '是', info3: 'int', info4: '是否是异常金额，0否，1是,默认否（vems v2.18开始 vems开始传此值，之前版本默认为：isAbnormal=0）' },
                        { info1: 'key', info2: '否', info3: 'String', info4: '授权商标识（采用预存款扣费的车辆账单传此字段，仅支持云停车场）' },
                        { info1: 'thirdBillCode', info2: '否', info3: 'String', info4: '第三方账单号（采用预存款扣费的车辆账单传此字段，仅支持云停车场）' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'otherAttr', info2: '否', info3: 'JSONObject', info4: '附加信息' },
                        { info1: 'couponList', info2: '是', info3: 'JSONArray', info4: '支付优惠列表。couponOrigin和couponType的组合决定优惠的类型：\
                                                                    couponOrigin=2 couponType=0 第三方积分；\
                                                                    couponOrigin=2 couponType=2 第三方优惠（缴费带券，v1.12.0版本起）,v1.12.0版本之前与停车场线上活动优惠重复使用0、3；\
                                                                    couponOrigin=2 couponType=3 第三方优惠；\
                                                                    couponOrigin=0 couponType=0 本地优惠（vems人工优惠）；\
                                                                    couponOrigin=0 couponType=1 电子券优惠；\
                                                                    couponOrigin=0 couponType=2 vems计费系数（计费规则补充不体现在账单中）；\
                                                                    couponOrigin=0 couponType=3 停车场线上活动优惠；\
                                                                    couponOrigin=1 couponType=1 城市运营券优惠；\
                                                                    couponOrigin=1 couponType=2 城市运营积分；' },
                        ]
                },{
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponOrigin', info2: '是', info3: 'int', info4: '优惠来源，0停车场 1智慧停车 2第三方定义优惠' },
                        { info1: 'couponType', info2: '是', info3: 'int', info4: '与临停缴费上报中的couponType相同。优惠类型：具体对应优惠来源（couponOrigin）所对应的类型, 停车场类型：0本地优惠 1电子券优惠 2vems计费系数 3停车场线上活动优惠，智慧停车类型：1城市运营券优惠 2城市运营积分，第三方类型（针对智慧停车开放平台）：0第三方积分 2第三方优惠（缴费带券） 3第三方优惠' },
                        { info1: 'reliefType', info2: '否', info3: 'int', info4: '减免类型，券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券的编码' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '实际的抵扣金额' },
                        ]
                },{
                    titleName: 'otherAttr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'begin', info2: '是', info3: 'int', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'carChargeDesc', info2: '是', info3: 'int', info4: '车辆描述' },
                        { info1: 'carChargeType', info2: '否', info3: 'int', info4: '车辆类型 0未知 1临时车' },
                        { info1: 'chargeBillNumber', info2: '否', info3: 'int', info4: '智慧停车微信缴费账单编号' },
                        { info1: 'chargeTime', info2: '否', info3: 'int', info4: '缴费时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'end', info2: '否', info3: 'int', info4: '' },
                        { info1: 'isCanUse', info2: '否', info3: 'int', info4: '' },
                        { info1: 'onlineSearch', info2: '否', info3: 'int', info4: '' },
                        { info1: 'parkAmount', info2: '是', info3: 'Decimal', info4: '总停车费用' },
                        { info1: 'timeoutLength', info2: '是', info3: 'int', info4: '缴费后离场时长' },
                        { info1: 'scoreInfo', info2: '否', info3: 'JSONObject', info4: '积分信息' },
                        { info1: 'openId', info2: '否', info3: 'String', info4: 'openId' },
                        { info1: 'merchantCode', info2: '否', info3: 'String', info4: '入账商户号（通过智慧停车微信缴费）' },
						{ info1: 'bankType', info2: '否', info3: 'String', info4: '付款银行' },
                        ]
                },{
                    titleName: 'scoreInfo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'scoreTotal', info2: '是', info3: 'int', info4: '积分合计值（简单做积分、城市运营积分面值的面值和）' },
                        { info1: 'scoreValue', info2: '是', info3: 'Decimal', info4: '积分抵扣合计金额' },
                        { info1: 'detail', info2: '否', info3: 'JSONArray', info4: '积分使用详细信息' },
                        ]
                },{
                    titleName: 'detail',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'integral', info2: '是', info3: 'int', info4: '抵扣积分值' },
                        { info1: 'discountAmount', info2: '是', info3: 'Decimal', info4: '抵扣金额' },
                        { info1: 'scoreType', info2: '是', info3: 'int', info4: '积分类型。0积分 1城市运营积分' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportParkingFee.vue